(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/voucher-handler.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/voucher-handler.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const logger = svs.core.log.getLogger('components:game-handler');
const _svs$ticketgames$game = svs.ticketgames.gameHandler.utils,
  buildLeiaGameCatalogQuery = _svs$ticketgames$game.buildLeiaGameCatalogQuery,
  LeiaGameStatus = _svs$ticketgames$game.LeiaGameStatus,
  LeiaEngineCode = _svs$ticketgames$game.LeiaEngineCode;
const getThemeGame = (games, skinId) => {
  let themeToUse = null;
  const themeGame = games.find(game => {
    var _game$themes;
    return game.isThemeable && ((_game$themes = game.themes) === null || _game$themes === void 0 ? void 0 : _game$themes.find(_ref => {
      let themeName = _ref.themeName;
      return themeName.toLowerCase() === skinId;
    }));
  });
  if (themeGame) {
    themeGame.themes.forEach(theme => {
      if (theme.themeName.toLowerCase() === skinId) {
        themeToUse = theme;
      }
    });
    const variations = themeToUse.skins.length;
    return _objectSpread(_objectSpread({}, themeGame), {}, {
      theme: themeToUse.themeName,
      skins: themeToUse.skins,
      variations
    });
  }
  const game = games.find(game => game.theme.toLowerCase() === skinId);
  if (!game) {
    const applicableGames = games === null || games === void 0 ? void 0 : games.map(_ref2 => {
      let type = _ref2.type;
      return type;
    });
    logger.warn("No matching game found for theme ".concat(skinId, " for applicable games: ").concat(applicableGames));
  }
  return game;
};
const getSessionStorageData = KEY => new Promise(resolve => {
  svs.core.userSession.get(KEY, (err, data) => {
    if (!err) {
      resolve(data);
    } else {
      resolve(null);
    }
  });
});
const fetchLEIAGames = async onlyOpenGames => {
  const query = buildLeiaGameCatalogQuery({
    engineCode: LeiaEngineCode.ITG,
    status: onlyOpenGames ? LeiaGameStatus.OPEN : ''
  });
  try {
    logger.debug('fetching games from LEIA...');
    const path = "".concat(svs.core.urlMapping.get('ticketsApi'), "/tickets-catalog").concat(query);
    const response = await fetch("".concat(window.location.origin).concat(path));
    if (!response.ok) {
      throw new Error('Failed to fetch games from LEIA');
    }
    const data = await response.json();
    logger.debug('...successfully fetched games from LEIA');
    return data.map(svs.ticketgames.gameHandler.helpers.mapLeiaGames);
  } catch (err) {
    logger.warn('Failed to fetch games from LEIA', err);
    return [];
  }
};
const fetchVoucherConfigs = async () => {
  const VOUCHER_CONFIGS_KEY = 'ticketVoucherConfigs';
  let voucherConfigs = await getSessionStorageData(VOUCHER_CONFIGS_KEY);
  if (voucherConfigs) {
    logger.debug('Using cached voucher configs');
    return voucherConfigs;
  }
  try {
    logger.debug('fetching voucher configs...');
    const _await$svs$tur$apiCal = await svs.tur.apiCaller.ticketgames.getVouchersConfig(),
      response = _await$svs$tur$apiCal.response;
    logger.debug('...successfully fetched voucher configs');
    voucherConfigs = response.configs;
    svs.core.userSession.set(VOUCHER_CONFIGS_KEY, voucherConfigs);
    return voucherConfigs;
  } catch (err) {
    logger.warn('Failed to fetch voucher configs', err);
    return [];
  }
};
const getVoucherGames = async function () {
  let onlyOpenGames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const STORAGE_GAMES_KEY = "leiaVoucherTicketGames-".concat(onlyOpenGames ? 'open' : 'all');
  const _svs$gameHandler$data = svs.gameHandler.data.games.cntTicketGames,
    cntTicketGames = _svs$gameHandler$data === void 0 ? [] : _svs$gameHandler$data;
  let games = await getSessionStorageData(STORAGE_GAMES_KEY);
  if (games) {
    logger.debug('Using cached games for vouchers games');
    return games;
  }
  const _await$Promise$all = await Promise.all([fetchLEIAGames(onlyOpenGames), fetchVoucherConfigs()]),
    _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
    _await$Promise$all2$ = _await$Promise$all2[0],
    leiaGames = _await$Promise$all2$ === void 0 ? [] : _await$Promise$all2$,
    _await$Promise$all2$2 = _await$Promise$all2[1],
    voucherConfigs = _await$Promise$all2$2 === void 0 ? [] : _await$Promise$all2$2;
  if (leiaGames.length > 0 && voucherConfigs.length > 0) {
    games = svs.ticketgames.gameHandler.mapScratchTicketsFromContentList(leiaGames, cntTicketGames, voucherConfigs) || [];
    svs.core.userSession.set(STORAGE_GAMES_KEY, games);
  }
  return games || [];
};
setGlobal('svs.ticketgames.gameHandler.getVoucherGames', getVoucherGames); 
setGlobal('svs.ticketgames.gameHandler.chooseGameForVoucher', async voucher => {
  var _voucher$skinId;
  const onlyOpenGames = voucher.state === 'ACTIVE';
  const games = await svs.ticketgames.gameHandler.getVoucherGames(onlyOpenGames);
  const skinId = (_voucher$skinId = voucher.skinId) === null || _voucher$skinId === void 0 ? void 0 : _voucher$skinId.toString().toLowerCase();
  const applicableGames = games.filter(game => Number(game.voucherId) === Number(voucher.voucherConfigId)).sort((a, b) => (a.claimableAs.indexOf(a.type) + 1 || Infinity) - (b.claimableAs.indexOf(b.type) + 1 || Infinity));
  const themeGame = getThemeGame(applicableGames, skinId);
  const game = themeGame || applicableGames[0];
  if (!game) {
    logger.warn('No applicable game found for voucher', JSON.stringify(voucher));
  } else {
    game.normalizeSkinId = skinId => skinId > 0 && skinId <= game.variations ? skinId : 1;
    const msg = "ticket with gameCode ".concat(game.type, " found for voucher with voucherConfigId ").concat(voucher.voucherConfigId, ", themeName ").concat(skinId, " and ticketPosition ").concat(voucher === null || voucher === void 0 ? void 0 : voucher.ticketPosition, " - theme ").concat(game.theme, " with skinId ").concat(game.normalizeSkinId(voucher === null || voucher === void 0 ? void 0 : voucher.ticketPosition), " shown");
    logger.debug(msg);
  }
  return game;
});

 })(window);